import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostUpdateMessanger = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'put',
                url: urls.PUT_MESSANGER
            }); 
            window.location.replace('/settings/messanger')
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostUpdateMessanger as SetPostUpdateMessanger
}